import React, { useState } from "react";
import useCreateBlog from "../hooks/useCreateBlog";
import useUploadFiles from "../../../services/hooks/useUploadFiles";

// components
import RichText from "../../../component/element/forms/RichText";
import TextInput from "../../../component/element/forms/TextInput";
import SelectOption from "../../../component/element/forms/SelectOption";
import Upload from "../../../component/modals/upload";

// constants
import { MdSubtitles } from "react-icons/md";
import { FaLongArrowAltLeft } from "react-icons/fa";

// state
import { create_blog, get_categories } from "../../../services/apis/blog";
import { useAppDispatch, useAppSelector } from "../../../store";
import { useNavigate } from "react-router-dom";
import Button from "../../../component/element/forms/Button";
import { setLoading } from "../../../store/slices/blog";
// import { FaTrashCan } from "react-icons/fa6";

const CreateBlog: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [imgPath, setImgPath] = useState("");
  const categories = useAppSelector(({ blog }) => blog.categories);
  // const loading = useAppSelector(({ blog }) => blog.loading);

  const { uploadFile, deleteFiles, loader } = useUploadFiles();

  const { data, error, setData, setError, onValidate } = useCreateBlog();

  const handleOk = () => {
    dispatch(setLoading(true));
    const validate = onValidate();
    if (!validate) return;
    create_blog(data, dispatch);
  };

  const onLoad = React.useCallback(() => {
    get_categories(dispatch);
  }, [dispatch]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  return (
    <div>
      <div className="w-full flex justify-between items-center mb-6">
        <div>
          <h2 className="font-bold text-xl capitalize mb-0">Edit Blog</h2>
        </div>
        <div className="flex items-center ">
          <Button
            title="Back"
            children={<FaLongArrowAltLeft className="mr-2" />}
            onClick={() => navigate(-1)}
            className="w-32 text-white"
          />
        </div>
      </div>

      <div className="bg-white p-6 rounded-xl shadow-md space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <TextInput
            name="title"
            type="text"
            label="Title"
            value={data.title}
            placeholder="Enter Title"
            icon={<MdSubtitles size={20} />}
            status={error.title}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const { value, name } = e.target;
              setData((prev) => ({ ...prev, [name]: value }));
              setError((prev) => ({ ...prev, [name]: "" }));
            }}
          />

          <SelectOption
            items={categories}
            label="Category"
            placeholder="Select Category"
            value={data.blog_category_id?.toString()}
            onChange={(res) => {
              setData((prev) => ({
                ...prev,
                blog_category_id: Number(res),
              }));
              setError((prev) => ({ ...prev, blog_category_id: "" }));
            }}
          />
        </div>

        <Upload
          title="Upload Image"
          label="JPG or PNG"
          name="blog_file"
          loading={loader}
          status={error.image}
          completed={data.image ? true : false}
          imgPreview={data.image}
          onChange={async (fileOrFiles) => {
            const paths = await uploadFile(fileOrFiles as File, "blog");

            if (paths.length > 0) {
              const img_path = paths[0].base_url + "/" + paths[0].path;
              setData((prev) => ({ ...prev, image: img_path }));
              setError((prev) => ({ ...prev, image: "" }));
              setImgPath(paths[0].path);
            }
          }}
          onDelete={async () => {
            if (imgPath) {
              await deleteFiles(imgPath);
              setData((prev) => ({ ...prev, image: "" }));
            }
          }}
        />
        {/* 
        To do----- waiting for update from the backend
        {data.image && (
          <div>
            <div className="relative w-42 h-auto">
              <img src={data.image} alt="" className="w-full h-96" />
              <div className="absolute top-3 right-3 bg-white/70 backdrop-blur-sm hover:bg-white p-2 rounded-full cursor-pointer">
                <FaTrashCan
                  className="text-red-500"
                  onClick={() => setData((prev) => ({ ...prev, image: "" }))}
                />
              </div>
            </div>
          </div>
        )} */}

        <RichText
          value={data.article}
          placeholder="Write Article"
          onChange={(res) => setData((prev) => ({ ...prev, article: res }))}
        />

        <div className="flex justify-end">
          <Button
            type="submit"
            title="Submit"
            // loading={loading}
            onClick={handleOk}
            className="w-32 text-white"
          />
        </div>
      </div>
    </div>
  );
};

export default CreateBlog;
